import clx from "classnames";
import React from "react";

const Padding = {
    none: "",
    small: "p-0.5 sm:p-0.75",
    default: "px-1 py-1.5",
    large: "p-1 sm:p-1.5",
};

export interface CardProps {
    padding?: keyof typeof Padding;
    children: React.ReactNode;
    /**
     * Typically we disallow this on components however this is a layout component.
     * We should restrict this to
     * layout classes only, grid, maxwidth, flow classes etc.
     */
    className?: string;
    ref?: React.RefObject<HTMLDivElement>;
}

const Card = ({ children, padding = "default", ref, className }: CardProps) => {
    const cn = clx("bg-white rounded w-full", Padding[padding], className);

    return <div ref={ref} className={cn}>{children}</div>;
};

export default Card;
